import React, { forwardRef } from 'react';
import { css, cx } from '@emotion/css';
import { theme, expandFontTheme } from '@contrast-security-inc/design-system-foundations';
export const validTextColors = [
    'black',
    'neutral30',
    'neutral50',
    'neutral60',
    'neutral70',
    'neutral80',
    'neutral100',
    'red70',
    'white',
    'turquoise90',
];
const textStyles = (font, color) => css `
  ${expandFontTheme(theme.font[font])};
  color: ${color ? theme.color[color] : 'inherit'};
`;
export const Text = forwardRef(({ as = 'span', color, children, className, font = 'body', testId, ...rest }, ref) => {
    if (color && !validTextColors.includes(color)) {
        throw new Error(`Invalid text color, valid colors are ${validTextColors} and you passed in ${color}.`);
    }
    const classes = cx(textStyles(font, color), className, 'ds-text');
    return React.createElement(as || 'span', {
        className: classes,
        'data-testid': testId,
        ref,
        ...rest,
    }, children);
});
Text.displayName = 'Text';
